module.exports = __webpack_public_path__ + "media/images/icons/picture-48c2f5d08a22fc717c806749ff188b7a.svg";